import {createStore} from 'vuex'

const online = require('../assets/img/online.png')
const outline = require('../assets/img/outline.png')
const alarm = require('../assets/img/alarm.gif')

const pageAction = localStorage.getItem('page-action') ? JSON.parse(localStorage.getItem('page-action')) : []

export default createStore({
    state: {
        online: online,
        outline: outline,
        alarm: alarm,
        amap_key: '0880d359f6e7246e6397d305e1c63211',
        amap_version: '1.4.15',
        alarm_imei: '',
        isLogin: 0,
        pageAction: pageAction
    },
    mutations: {
        SET_ALARM_IMEI(state, imei) {
            state.alarm_imei = imei
        },
        SET_LOGIN_STATUS(state, status) {
            state.isLogin = status
        },
        SET_PAGE_ACTION(state, data) {
            state.pageAction = data
        }
    },
    actions: {},
    modules: {}
})
